(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bundle-pack-switcher"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';

  var cfgEl = document.getElementById('bundle-pack-data');
  if (!cfgEl) return;
  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch(e) { return; }

  var store = {};
  if (cfg.pack1 && cfg.pack1.id) store['1'] = cfg.pack1;

  var root     = cfgEl.closest('[data-bundle-pack-root]');
  if (!root) return;
  var tilesEl  = root.querySelector('.bundle-variant-tiles');
  var labelEl  = root.querySelector('.bundle-option-label');
  var valueEl  = root.querySelector('.bundle-option-value');
  var idInput  = root.querySelector('.bundle-variant-id');
  var packBtns = root.querySelectorAll('.bundle-pack-btn');

  // Store original image srcs for pack 1 restore
  var origMainSrc  = null;
  var origThumbSrc = null;

  function swapGallery(packKey) {
    var mainImg  = document.querySelector('.product-gallery__carousel-item.is-selected img, .product-gallery__carousel-item:not(.product-gallery__carousel-item--hidden) img, .product-gallery__image');
    var thumbImg = document.querySelector('.product-gallery__thumbnail.is-nav-selected img, .product-gallery__thumbnail img');

    // Save originals from pack 1 on first swap
    if (!origMainSrc  && mainImg)  origMainSrc  = mainImg.src;
    if (!origThumbSrc && thumbImg) origThumbSrc = thumbImg.src;

    if (packKey === '1') {
      if (mainImg  && origMainSrc)  mainImg.src  = origMainSrc;
      if (thumbImg && origThumbSrc) thumbImg.src = origThumbSrc;
      return;
    }

    // Get image src from fetched product data
    var p = store[packKey];
    if (!p) return;

    // Try featured_image from first variant, then product featured_image
    var src = null;
    if (p.variants && p.variants.length && p.variants[0].featured_image) {
      src = p.variants[0].featured_image.src;
    }
    if (!src && p.featured_image) {
      src = p.featured_image.src || p.featured_image;
    }
    if (!src && p.images && p.images.length) {
      src = p.images[0];
      if (typeof src !== 'string') src = src.src || null;
    }
    if (!src) return;

    // Swap main image and thumbnail
    if (mainImg)  mainImg.src  = src;
    if (thumbImg) thumbImg.src = src;
  }

  // ── Fetch pack data ───────────────────────────────────────────────
  function fetchByHandle(key, handle) {
    fetch('/products/' + handle + '.js')
      .then(function(r) { return r.json(); })
      .then(function(d) {
        store[key] = d;
        updatePackLabels();
        if (activeKey === key) renderTiles(key);
      })
      .catch(function(e) { console.error('[BPS] fetch error', key, e); });
  }

  function loadPack(key, handle, id) {
    if (handle && handle !== 'null' && handle !== '') {
      fetchByHandle(key, handle);
    } else if (id && id !== 'null' && id !== 0 && id !== '0') {
      fetch('/products.json?product_id=' + id)
        .then(function(r) { return r.json(); })
        .then(function(d) {
          var match = (d.products||[]).filter(function(p) { return String(p.id)===String(id); })[0];
          if (match && match.handle) fetchByHandle(key, match.handle);
        }).catch(function(){});
    }
  }

  loadPack('3', cfg.handle3, cfg.id3);
  loadPack('5', cfg.handle5, cfg.id5);

  // ── Option helpers ────────────────────────────────────────────────
  function getVal(v, idx) {
    var k = ['option1','option2','option3'][idx];
    if (v[k] !== null && v[k] !== undefined && v[k] !== '') return String(v[k]);
    var o = (v.options||[])[idx];
    return o==null ? null : (typeof o==='object' ? String(o.name||'') : String(o));
  }
  function getName(p, idx) {
    var o = (p.options||[])[idx];
    return o==null ? 'Size' : (typeof o==='object' ? String(o.name||'Size') : String(o));
  }
  function priIdx(p) {
    var opts = p.options||[];
    for (var i=0;i<opts.length;i++) {
      var n = typeof opts[i]==='object' ? String(opts[i].name||'') : String(opts[i]);
      if (n.toLowerCase().indexOf('size')!==-1) return i;
    }
    return 0;
  }
  function uniqueVals(p) {
    var idx=priIdx(p), seen={}, out=[];
    (p.variants||[]).forEach(function(v){
      var val=getVal(v,idx);
      if (val&&!seen[val]){seen[val]=true;out.push(val);}
    });
    return out;
  }
  function bestVariant(p, target) {
    var idx=priIdx(p), vs=p.variants||[];
    for (var i=0;i<vs.length;i++) if (getVal(vs[i],idx)===target&&vs[i].available) return vs[i];
    for (var i=0;i<vs.length;i++) if (getVal(vs[i],idx)===target) return vs[i];
    for (var i=0;i<vs.length;i++) if (vs[i].available) return vs[i];
    return vs[0]||null;
  }
  function isValAvailable(p, val) {
    var idx=priIdx(p), vs=p.variants||[];
    for (var i=0;i<vs.length;i++) if (getVal(vs[i],idx)===val&&vs[i].available) return true;
    return false;
  }

  // ── Money ─────────────────────────────────────────────────────────
  function toDollars(raw) {
    if (raw===null||raw===undefined) return 0;
    var n=parseFloat(String(raw).replace(/[^0-9.]/g,''));
    if (isNaN(n)) return 0;
    if (Number.isInteger(n)&&n>100) return n/100;
    return n;
  }
  function fmt(raw) {
    var d=toDollars(raw);
    var s='$'+d.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g,',');
    if (cfg.currencyCodeEnabled) {
      var code=(window.Shopify&&window.Shopify.currency&&window.Shopify.currency.active)
        ?window.Shopify.currency.active:'NZD';
      return s+' '+code;
    }
    return s;
  }

  // ── Pack labels ───────────────────────────────────────────────────
  function updatePackLabels() {
    var p1=store['1'];
    if (!p1||!p1.variants||!p1.variants.length) return;
    var price1=toDollars(p1.variants[0].price);
    var pu1=root.querySelector('[data-bps-per-unit="1"]');
    if (pu1) pu1.textContent='$'+price1.toFixed(2)+'/unit';
    ['3','5'].forEach(function(key){
      var p=store[key];
      if (!p||!p.variants||!p.variants.length) return;
      var pc=parseInt(key,10), pp=toDollars(p.variants[0].price);
      var discPct=price1>0?Math.round((price1*pc-pp)/(price1*pc)*100):0;
      var pu=root.querySelector('[data-bps-per-unit="'+key+'"]');
      if (pu) pu.textContent='$'+(pp/pc).toFixed(2)+'/unit';
      var badge=root.querySelector('[data-bps-badge="'+key+'"]');
      if (badge&&discPct>0){badge.textContent=discPct+'% OFF';badge.style.visibility='';}
    });
  }

  // ── Apply variant ─────────────────────────────────────────────────
  function apply(variant) {
    if (!variant) return;
    idInput.value=variant.id;
    document.querySelectorAll('input.update_check[name="id"]').forEach(function(el){el.value=variant.id;});
    var addBtn=document.querySelector('.product-form__add-button');
    if (addBtn) {
      if (variant.available){addBtn.removeAttribute('disabled');addBtn.classList.remove('button--disabled');}
      else{addBtn.setAttribute('disabled','disabled');addBtn.classList.add('button--disabled');}
    }
    var regularEl=root.querySelector('[data-bps-regular-price]');
    var saleEl=root.querySelector('[data-bps-price]');
    var compareEl=root.querySelector('[data-bps-compare-price]');
    var saleValEl=root.querySelector('[data-bps-price-val]');
    var compareValEl=root.querySelector('[data-bps-compare-val]');
    var pd=toDollars(variant.price), cd=variant.compare_at_price?toDollars(variant.compare_at_price):0;
    if (cd&&cd>pd) {
      if (saleValEl) saleValEl.textContent=fmt(variant.price);
      if (compareValEl) compareValEl.textContent=fmt(variant.compare_at_price);
      if (saleEl) saleEl.style.display='';
      if (compareEl) compareEl.style.display='';
      if (regularEl) regularEl.style.display='none';
    } else {
      if (regularEl){regularEl.textContent=fmt(variant.price);regularEl.style.display='';}
      if (saleEl) saleEl.style.display='none';
      if (compareEl) compareEl.style.display='none';
    }
    idInput.dispatchEvent(new Event('change',{bubbles:true}));
  }

  // ── Render tiles ──────────────────────────────────────────────────
  var activeKey='1', activeVal=null;

  function renderTiles(key) {
    var p=store[key]; if (!p) return;
    var idx=priIdx(p), values=uniqueVals(p);
    if (labelEl) labelEl.textContent=getName(p,idx);
    tilesEl.innerHTML='';
    values.forEach(function(val,i){
      var avail=isValAvailable(p,val);
      var wrap=document.createElement('div'); wrap.className='block-swatch';
      var btn=document.createElement('button'); btn.type='button';
      btn.className='block-swatch__item bundle-variant-btn'+(i===0?' is-active':'')+(avail?'':' is-unavailable');
      btn.setAttribute('data-opt',val);
      if (!avail) btn.setAttribute('disabled','disabled');
      btn.innerHTML='<span class="block-swatch__item-text">'+val+'</span>';
      wrap.appendChild(btn); tilesEl.appendChild(wrap);
    });
    var toSelect=null;
    if (activeVal) values.forEach(function(v){if(v===activeVal&&isValAvailable(p,v))toSelect=v;});
    if (!toSelect) values.forEach(function(v){if(!toSelect&&isValAvailable(p,v))toSelect=v;});
    if (!toSelect) toSelect=values[0];
    selectVal(key,toSelect);
  }

  function selectVal(key,val) {
    activeVal=val;
    tilesEl.querySelectorAll('.bundle-variant-btn').forEach(function(b){
      b.classList.toggle('is-active',b.getAttribute('data-opt')===val);
    });
    if (valueEl) valueEl.textContent=val||'';
    var p=store[key]; if(p) apply(bestVariant(p,val));
  }

  packBtns.forEach(function(btn){
    btn.addEventListener('click',function(){
      var key=btn.getAttribute('data-pack');
      activeKey=key;
      packBtns.forEach(function(b){b.classList.toggle('is-active',b===btn);});
      swapGallery(key);
      if (store[key]) renderTiles(key);
      else tilesEl.innerHTML='<span style="opacity:0.5;font-size:0.85em">Loading\u2026</span>';
    });
  });

  tilesEl.addEventListener('click',function(e){
    var btn=e.target.closest('.bundle-variant-btn');
    if (!btn||btn.disabled) return;
    e.preventDefault();
    tilesEl.querySelectorAll('.bundle-variant-btn').forEach(function(b){b.classList.remove('is-active');});
    btn.classList.add('is-active');
    selectVal(activeKey,btn.getAttribute('data-opt'));
  });

  updatePackLabels();
  renderTiles('1');

  // Fix broken carousel/thumbnail images caused by _{width}x lazy-load template
  // in product-gallery.liquid. Lazysizes picks a size that doesn't exist on CDN.
  // Fix: when image errors, use data-src or strip size suffix.
  function fixImg(img) {
    var dataSrc = img.getAttribute('data-src');
    if (dataSrc && dataSrc.indexOf('{width}') === -1 && dataSrc !== img.src) {
      img.src = dataSrc;
      return;
    }
    if (img.src && img.src.indexOf('/files/') !== -1) {
      img.src = img.src.replace(/_\d+x\./, '.');
    }
  }

  function fixAllGalleryImages() {
    document.querySelectorAll(
      '.product-gallery__image, .product-gallery__thumbnail img'
    ).forEach(function(img) {
      if (!img.complete || img.naturalWidth === 0) fixImg(img);
      // Also attach onerror in case it breaks later (e.g. on swipe/lazy load)
      img.addEventListener('error', function() { fixImg(this); }, { once: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixAllGalleryImages);
  } else {
    fixAllGalleryImages();
  }
  window.addEventListener('load', fixAllGalleryImages);

}());
  } catch(e) { console.error(e); }
})();

})();
